import CELL_DATA_TYPES from '../cell-types.config';

export const LISTING_COLUMNS = [
  {
    id: 'name',
    label: 'Name',
    width: '15%',
    align: 'left',
    dataKey: 'name',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'email',
    label: 'Email',
    width: '15%',
    align: 'left',
    dataKey: 'email',
    sortable: true,
    type: CELL_DATA_TYPES.EMAIL,
  },
  {
    id: 'phone',
    label: 'Phone',
    width: '15%',
    align: 'left',
    dataKey: 'phone',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'message',
    label: 'Message',
    width: '25%',
    align: 'left',
    dataKey: 'message',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '15%',
    align: 'center',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [];
